import { AxiosResponse } from 'axios';
import { live } from '@/api/live';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { ILiveApiListResponse, ILiveFilters } from '@/types/event/live';

export const liveService = {
    async list(params: IListParams<ILiveFilters>): Promise<AxiosResponse<ILiveApiListResponse>> {
        try {
            const response = await baseListService<ILiveApiListResponse>(live, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            throw e;
        }
    },
};
